import { motion } from "framer-motion";
import { EASE } from "@/lib/site";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, desc, testid, align = "left" }) => (
  <Reveal className={`max-w-3xl ${align === "right" ? "lg:ml-auto lg:text-right" : ""}`}>
    <p className="eyebrow mb-5" data-testid={`${testid}-eyebrow`}>{eyebrow}</p>
    <h2 className="display text-4xl sm:text-5xl lg:text-6xl leading-[1.02]" data-testid={`${testid}-title`}>{title}</h2>
    {desc && <p className="mt-6 text-base md:text-lg text-[color:var(--muted)] max-w-xl leading-relaxed inline-block">{desc}</p>}
  </Reveal>
);

export const Logo = ({ className = "w-9 h-9" }) => (
  <img src="/logo-mark.png" alt="Vedic Yagya Astrology logo" className={`${className} object-contain`} />
);

export const Num = ({ n }) => <span className="font-mono text-xs tracking-[0.2em] text-[color:var(--gold)]">{String(n).padStart(2, "0")}</span>;
